import { ActionTypeBlog } from "../../constants/ActionTypesBlog";

const initialState = {
	articles: [],
	blogCategories: [],
	loading: false,
	blogCategoriesLoading: false,
	error: null,
	saving: false,
};

export default function blogReducer(state = initialState, action = {}) {
	switch (action.type) {
		// Articles
		case ActionTypeBlog.GET_BLOG_ARTICLES_BEGIN:
			return { ...state, loading: true, articles: [], error: null };
		case ActionTypeBlog.GET_BLOG_ARTICLES_ERROR:
			return { ...state, loading: false, error: action.payload };
		case ActionTypeBlog.GET_BLOG_ARTICLES_SUCCESS:
			return { ...state, loading: false, articles: action.payload };
		case ActionTypeBlog.ADD_EDIT_BLOG_ARTICLE_BEGIN:
		case ActionTypeBlog.EDIT_BLOG_ARTICLE_BEGIN:
			return { ...state, saving: true };
		case ActionTypeBlog.ADD_EDIT_BLOG_ARTICLE_ERROR:
		case ActionTypeBlog.ADD_EDIT_BLOG_ARTICLE_SUCCESS:
		case ActionTypeBlog.EDIT_BLOG_ARTICLE_ERROR:
		case ActionTypeBlog.EDIT_BLOG_ARTICLE_SUCCESS:
			return { ...state, saving: false };
		case ActionTypeBlog.DELETE_BLOG_ARTICLE_BEGIN:
			return { ...state, loading: true };
		case ActionTypeBlog.DELETE_BLOG_ARTICLE_ERROR:
			return { ...state, loading: false };
		case ActionTypeBlog.DELETE_BLOG_ARTICLE_SUCCESS:
			return { ...state, articles: state.articles.filter(a => a.id !== action.payload), loading: false };

		// Categories
		case ActionTypeBlog.GET_BLOG_CATEGORIES_BEGIN:
			return { ...state, blogCategories: [], blogCategoriesLoading: true };
		case ActionTypeBlog.CHANGE_BLOG_CATEGORY_ICON_VISIBILITY_BEGIN:
		case ActionTypeBlog.CHANGE_BLOG_CATEGORY_VISIBILITY_BEGIN:
		case ActionTypeBlog.MOVE_BLOG_CATEGORY_BEGIN:
		case ActionTypeBlog.EDIT_BLOG_CATEGORY_BEGIN:
			return { ...state, blogCategoriesLoading: true };
		case ActionTypeBlog.GET_BLOG_CATEGORIES_ERROR:
		case ActionTypeBlog.DELETE_BLOG_CATEGORY_ERROR:
			return { ...state, blogCategoriesLoading: false };
		case ActionTypeBlog.GET_BLOG_CATEGORIES_SUCCESS:
		case ActionTypeBlog.ADD_BLOG_CATEGORY_SUCCESS:
			return { ...state, blogCategories: action.payload, blogCategoriesLoading: false };
		case ActionTypeBlog.EDIT_BLOG_CATEGORY_SUCCESS:
			return { ...state, blogCategories: state.blogCategories, blogCategoriesLoading: false };
		case ActionTypeBlog.EDIT_BLOG_CATEGORY_ERROR:
		case ActionTypeBlog.ADD_BLOG_CATEGORY_ERROR:
			return { ...state, blogCategoriesLoading: false };
		case ActionTypeBlog.ADD_BLOG_CATEGORY_BEGIN:
		case ActionTypeBlog.DELETE_BLOG_CATEGORY_BEGIN:
			return { ...state, blogCategoriesLoading: true };
		case ActionTypeBlog.DELETE_BLOG_CATEGORY_SUCCESS:
			return {
				...state,
				blogCategories: state.blogCategories.filter(cat => action.payload !== cat.id),
				blogCategoriesLoading: false,
			};
		case ActionTypeBlog.GET_BLOG_CATEGORY_ICON_VISIBILITY_ERROR:
			return { ...state, blogCategoriesLoading: false };
		case ActionTypeBlog.CHANGE_BLOG_CATEGORY_ICON_VISIBILITY_ERROR:
		case ActionTypeBlog.CHANGE_BLOG_CATEGORY_VISIBILITY_ERROR:
		case ActionTypeBlog.MOVE_BLOG_CATEGORY_ERROR:
		case ActionTypeBlog.MOVE_BLOG_CATEGORY_SUCCESS:
			return { ...state, blogCategoriesLoading: false };
		case ActionTypeBlog.GET_BLOG_CATEGORY_ICON_VISIBILITY_SUCCESS:
		case ActionTypeBlog.CHANGE_BLOG_CATEGORY_ICON_VISIBILITY_SUCCESS: {
			const isVisible = typeof action.payload === "object" ? action.payload.show : action.payload;
			return { ...state, blogCategoriesIconVisibility: isVisible, blogCategoriesLoading: false };
		}
		case ActionTypeBlog.CHANGE_BLOG_CATEGORY_VISIBILITY_SUCCESS: {
			const changedCategories = state.blogCategories.map(category =>
				action.payload.id === category.id ? { ...category, isVisible: action.payload.isVisible } : category,
			);
			return { ...state, blogCategories: changedCategories, blogCategoriesLoading: false };
		}
		case ActionTypeBlog.GET_BLOG_CATEGORY_ICONS_BEGIN:
			return { ...state, blogCategoryIcons: [], blogCategoryIconsLoading: true };
		case ActionTypeBlog.GET_BLOG_CATEGORY_ICONS_ERROR:
			return { ...state, blogCategoryIconsLoading: false };
		case ActionTypeBlog.GET_BLOG_CATEGORY_ICONS_SUCCESS:
			return { ...state, blogCategoryIcons: action.payload, blogCategoryIconsLoading: false };

		// Settings
		case ActionTypeBlog.GET_BLOG_SETTINGS_BEGIN:
			return {
				...state,
				isSettingsSaving: false,
				isSettingsLoading: true,
			};
		case ActionTypeBlog.GET_BLOG_SETTINGS_ERROR:
			return {
				...state,
				isSettingsLoading: false,
			};
		case ActionTypeBlog.GET_BLOG_SETTINGS_SUCCESS:
			return {
				...state,
				isSettingsLoading: false,
				blogSettings: action.payload,
			};
		case ActionTypeBlog.SET_BLOG_SETTINGS_BEGIN:
			return {
				...state,
				isSettingsLoading: true,
			};
		case ActionTypeBlog.SET_BLOG_SETTINGS_ERROR:
		case ActionTypeBlog.SET_BLOG_SETTINGS_SUCCESS:
			return {
				...state,
				isSettingsLoading: false,
			};
		case ActionTypeBlog.CHANGE_BLOG_ARTICLE_VISIBILITY_SUCCESS: {
			const changedArticls = state.articles.map(article =>
				action.payload.id === article.id ? { ...article, isVisible: action.payload.isVisible } : article,
			);

			return {
				...state,
				articles: changedArticls,
				loading: false,
			};
		}
		case ActionTypeBlog.HIGHLIGHT_BLOG_ARTICLE_BEGIN:
			return {
				...state,
				highlighteLoading: true,
			};
		case ActionTypeBlog.HIGHLIGHT_BLOG_ARTICLE_ERROR:
			return {
				...state,
				highlighteLoading: false,
			};
		case ActionTypeBlog.HIGHLIGHT_BLOG_ARTICLE_SUCCESS: {
			const highlightedArticles = state.articles.map(article =>
				action.payload.id === article.id ? { ...article, isHighlighted: action.payload.isHighlighted } : article,
			);
			return {
				...state,
				articles: highlightedArticles,
				highlighteLoading: false,
			};
		}

		default:
			return state;
	}
}
